import React from 'lib/react';
import {
  EVGrid,
  EVHelpOutline,
  EVList,
  EVListItem,
} from 'lib/components';
import PropTypes from 'prop-types';
import { useTranslation } from 'lib/translation';
import clsx from 'lib/clsx';
import { Link } from 'lib/router';
import {
  DASHBOARD_ROUTE, SUPPORT_ROUTE, ORDER_HISTORY_ROUTE, ORDER_ROUTE, FINALIZE_ORDER_ROUTE,
  UPGRADE_ROUTE,
  ORDER_BLUEPRINT_ROUTE,
  ANALYTICS_DASHBOARD_ROUTE,
} from 'constants/RouteConstants';
import history from 'store/CreateHistory';
import { useSelector } from 'lib/redux';
import useMediaQuery from 'hooks/useMediaQuery';
import { isEntitledForAnalyticsSelector, isOrderingDisabledSelector, evoneAppSelector } from 'utils/appSelectors.utils';
import { isAuthorized } from 'utils/auth.utils';
import { buildEvoneOauthLoginUrl } from 'utils/app.utils';
import UserProfile from './userMenu/UserProfile.component';
import HeaderStyles from '../HeaderStyles';
import SidebarUserMenu from './userMenu/SidebarUserMenu.component';
import AppsMenu from './AppsMenu.component';
import HorizonLink from './HorizonLink.component';

function HeaderNav(props) {
  const { handleSidebarClose } = props;

  const classes = HeaderStyles();
  const { t } = useTranslation();

  const isMobile = useMediaQuery(640);
  const isTablet = useMediaQuery(1024);
  const isSidebar = isMobile || isTablet;

  const currentURL = history.location.pathname;

  const isOrderFlowStarted = useSelector(({ order }) => order.isOrderFlowStarted);
  const isEntitledForAnalytics = useSelector(isEntitledForAnalyticsSelector);
  const isOrderingDisabled = useSelector(isOrderingDisabledSelector);
  const evoneApp = useSelector(evoneAppSelector);
  const evoneAppUrl = evoneApp?.appURL || evoneApp?.appUrl;

  const orderBtnText = ([ORDER_ROUTE, FINALIZE_ORDER_ROUTE, UPGRADE_ROUTE, ORDER_BLUEPRINT_ROUTE].includes(currentURL) && isOrderFlowStarted)
    ? t('Cancel Order')
    : t('Order');

  return (
    <>
      <EVGrid component="nav" style={{ flex: 1, width: '100%' }}>
        <EVList className={classes.headerLinksContainer}>
          {evoneAppUrl && (
            <EVListItem className={classes.headerLinksListItem}>
              <HorizonLink url={buildEvoneOauthLoginUrl(evoneAppUrl)} />
            </EVListItem>
          )}
          {isEntitledForAnalytics && (
            <EVListItem className={classes.headerLinksListItem}>
              <Link
                onClick={handleSidebarClose}
                to={ANALYTICS_DASHBOARD_ROUTE}
                id="dashboard-menu-item"
                className={clsx(
                  classes.menuLink,
                  (currentURL === ANALYTICS_DASHBOARD_ROUTE && isSidebar) && classes.selectedMenuLink,
                  (currentURL === ANALYTICS_DASHBOARD_ROUTE && !isSidebar) && classes.selectedPCMenuLink,
                )}
                aria-label={t('common__analytics')}
              >
                {t('common__analytics')}
              </Link>
            </EVListItem>
          )}
          <EVListItem className={classes.headerLinksListItem}>
            <Link
              onClick={handleSidebarClose}
              to={DASHBOARD_ROUTE}
              id="dashboard-menu-item"
              className={clsx(
                classes.menuLink,
                (currentURL === `${DASHBOARD_ROUTE}` && isSidebar) && classes.selectedMenuLink,
                (currentURL === `${DASHBOARD_ROUTE}` && !isSidebar) && classes.selectedPCMenuLink,
              )}
              aria-label={t('Dashboard')}
            >
              {t('Dashboard')}
            </Link>
          </EVListItem>
          <EVListItem className={classes.headerLinksListItem}>
            <Link
              onClick={handleSidebarClose}
              to={ORDER_HISTORY_ROUTE}
              id="order-history-menu-item"
              className={clsx(
                classes.menuLink,
                (currentURL === ORDER_HISTORY_ROUTE && isSidebar) && classes.selectedMenuLink,
                (currentURL === ORDER_HISTORY_ROUTE && !isSidebar) && classes.selectedPCMenuLink,
              )}
              aria-label={t('common__order_history')}
            >
              {t('common__order_history')}
            </Link>
          </EVListItem>
          {!isOrderingDisabled && (
          <EVListItem className={clsx(classes.headerLinksListItem, classes.menuLink)} style={{ padding: 0 }}>
            <Link
              onClick={handleSidebarClose}
              to={ORDER_ROUTE}
              id="order-menu-item"
              className={classes.orderBtn}
              aria-label={orderBtnText}
            >
              {orderBtnText}
            </Link>
          </EVListItem>
          )}
          {
        isSidebar && (
          <EVListItem className={classes.headerLinksListItem}>
            <Link
              onClick={handleSidebarClose}
              to={SUPPORT_ROUTE}
              className={clsx(classes.menuLink, (currentURL === SUPPORT_ROUTE) && classes.selectedMenuLink)}
              aria-label={t('Support')}
            >
              <EVHelpOutline className="supportIcon" />
              {t('Support')}
            </Link>
          </EVListItem>
        )
      }
        </EVList>
      </EVGrid>
      {isSidebar
        ? <SidebarUserMenu handleSidebarClose={handleSidebarClose} />
        : <UserProfile />}
      {isAuthorized() && <AppsMenu />}
    </>
  );
}

HeaderNav.propTypes = {
  handleSidebarClose: PropTypes.func.isRequired,
};

export default HeaderNav;
